import { render, staticRenderFns } from "./ExpenseEdit.vue?vue&type=template&id=5096f9ba&"
import script from "./ExpenseEdit.vue?vue&type=script&lang=js&"
export * from "./ExpenseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports